import './index.scss';
// import './blocks/block1/fsdpe-events-new-block'
import './blocks/fsdpe-add-to-calendar-block';
import './blocks/fsdpe-add-to-calendar-block/view';
import './blocks/fsdpe-add-to-calendar-block/style.scss';
import './blocks/fsdpe-events-calendar-block';
import './blocks/fsdpe-events-calendar-block/view';
import './blocks/fsdpe-events-calendar-block/style.scss';

import './blocks/fsdpe-events-map-block';
import './blocks/fsdpe-events-map-block/view';
import './blocks/fsdpe-events-map-block/style.scss';

import React from "react";
import domReady from '@wordpress/dom-ready';
import { createRoot } from '@wordpress/element';
import { SettingsPage } from './components/settings-page';
import { SingleMeta } from './components/single-meta';

domReady(() => {
    const metaboxElement = document.getElementById('fsdpe-events-metabox');
    if (metaboxElement) {
        const metaboxRoot = createRoot(metaboxElement);
        metaboxRoot.render(<SingleMeta />);
    }

    const settingsElement = document.getElementById('fsdpe-events-settings');
    if (settingsElement) {
        const settingsRoot = createRoot(settingsElement);
        settingsRoot.render(<SettingsPage />);
    }

});
